import { Component, OnInit } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { Subscription } from 'rxjs'

import { MessageService } from '../../../services/message.service'
import { TranslateService } from '@ngx-translate/core'
import { AnalyticsService } from '../../../services/analytics.service'

@Component({
    selector: 'app-submit-insurance-modal',
    templateUrl: './submit-insurance-modal.component.html',
    styleUrls: ['./submit-insurance-modal.component.scss'],
    standalone: false
})
export class SubmitInsuranceModalComponent implements OnInit 
{
	loginSessionExpiredSubscription: Subscription

	constructor(
		public dialogRef: MatDialogRef<SubmitInsuranceModalComponent>,
		private messageService: MessageService,
		public translateService: TranslateService,
    	public analyticsService: AnalyticsService
	) 
	{
		this.loginSessionExpiredSubscription = this.messageService.loginSessionExpired$.subscribe(() =>
		{
			this.closeModal()
		})
	}

	ngOnInit() 
	{
	}

	onInsuranceEmailClick() 
	{
		this.analyticsService.trackEvent('submit_insurance_email_click', {
			email_address: 'insurance@cdlsi.com',
			link_location: 'submit_insurance'
		})
	}

	onAssuranceEmailClick() 
	{
		this.analyticsService.trackEvent('submit_insurance_email_click', {
			email_address: 'assurance@cdlsi.com"',
			link_location: 'submit_insurance'
		})
	}

	closeModal(): void 
	{
		this.dialogRef.close();
	}
}
